import { currentActivePage } from "./pagination";
import { ref } from "vue";

const selectedTags = ref([]);
const tags = ref(<any>[]);

const convertTagtoSearchTag = tag => {
  const response = {
    tagId: tag.id,
    categoryId: tag.categoryId
  };
  return response;
};

const updateClearTags = () => {
  currentActivePage.value = 1;
  selectedTags.value = [];
};

const clearAllTags = () => {
  tags.value = [];
  updateClearTags();
};

const updateTags = (
  updateTags: {
    categoryId: string;
    count?: number;
    id: string;
    title: string;
  }[]
) => {
  tags.value = [...updateTags];
  currentActivePage.value = 1;
  selectedTags.value = updateTags.map(x => convertTagtoSearchTag(x));
};

const updateIndexTags = updateTags => {
  clearAllTags();
  if (updateTags[0].title == "reset") {
    return;
  }
  currentActivePage.value = 1;
  selectedTags.value = updateTags.map(x => convertTagtoSearchTag(x));
};

const clearTag = tag => {
  tags.value.splice(tags.value.indexOf(tag), 1);
  updateTags(tags.value);
};

export {
  updateClearTags,
  updateTags,
  convertTagtoSearchTag,
  clearTag,
  clearAllTags,
  updateIndexTags,
  tags,
  selectedTags
};
